var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxiworld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "100px",
    viewBox: "-16 -5 200 100",
    enableBackground: "new -16 -5 200 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F3C717",
    d: "M83.982,1.633c23.952,0,43.369,19.415,43.369,43.367 s-19.417,43.367-43.369,43.367c-23.95,0-43.366-19.415-43.366-43.367S60.032,1.633,83.982,1.633L83.982,1.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000119",
    d: "M84.7,2.231c1.132,0.02,2.253,0.082,3.36,0.188 c0.205,0.064,0.448,0.143,0.694,0.228c0.121,0.044,0.245,0.089,0.367,0.14c-2.197-0.152-2.197-0.152-4.39-0.221L84.7,2.231 L84.7,2.231z M90.281,2.692c0.94,0.14,1.868,0.313,2.782,0.513l0.316,0.102l0,0c0.081,0.025,0.081,0.025,0.121,0.041 c-1.219-0.191-1.219-0.191-2.524-0.368C90.748,2.877,90.516,2.782,90.281,2.692L90.281,2.692z M98.982,4.968 c0.598,0.228,1.194,0.47,1.778,0.724c1.389,0.68,2.746,1.429,4.089,2.251c0.358,0.23,0.677,0.441,0.993,0.655 c0,0.002,0,0.002,0,0.002c0.178,0.119,0.317,0.216,0.455,0.313c-1.607-0.596-1.607-0.596-3.312-1.146 c-1.305-0.956-2.632-1.802-3.978-2.545c-0.265-0.138-0.529-0.274-0.799-0.407c-0.119-0.057-0.119-0.057-0.233-0.113 C98.507,4.84,98.696,4.888,98.982,4.968L98.982,4.968z M109.793,11.022c2.602,2.001,4.965,4.297,7.046,6.838 c-0.571-0.369-0.619-0.398-1.337-0.815c-0.956-1.191-1.965-2.341-3.021-3.449c-0.208-0.211-0.421-0.421-0.632-0.632 c-0.186-0.179-0.398-0.383-0.65-0.615l0,0l0,0l0,0c-0.503-0.465-0.979-0.89-1.467-1.307l0,0c-0.067-0.054-0.067-0.054-0.162-0.137 L109.793,11.022L109.793,11.022z M117.99,19.339c0.198,0.264,0.39,0.528,0.583,0.797c1.418,2.138,2.7,4.374,3.846,6.718 c0.224,0.508,0.464,1.057,0.678,1.572c0.176,0.436,0.348,0.873,0.512,1.315c-0.705-0.451-0.705-0.451-1.545-0.874 c-1.104-2.803-2.412-5.477-3.883-7.979c-0.287-0.467-0.606-0.961-0.912-1.417c-0.238-0.351-0.48-0.697-0.7-1.008 C117.323,18.904,117.353,18.919,117.99,19.339L117.99,19.339z M119.503,68.801L119.503,68.801l-0.015,0.023l-0.017,0.022 l-0.013,0.023l-0.028,0.042l-0.016,0.023l-0.013,0.022l-0.018,0.022l-0.015,0.025l-0.015,0.023l-0.018,0.021l-0.029,0.043 l-0.015,0.023l-0.015,0.022c-0.406,0.609-0.827,1.205-1.265,1.789c-0.636,0.418-0.668,0.438-1.446,0.908 c1.548-2.263,2.965-4.702,4.205-7.272c0.262-0.569,0.496-1.108,0.717-1.649c0.205-0.502,0.398-1.009,0.589-1.519 c0.839-0.422,0.839-0.422,1.529-0.833c-1.062,2.662-2.307,5.199-3.706,7.605L119.503,68.801L119.503,68.801z M116.862,72.406 c-2.077,2.548-4.439,4.847-7.04,6.851l-0.219,0.113c0.359-0.302,0.682-0.582,1.03-0.893l0,0c0.129-0.117,0.129-0.117,0.284-0.259 l0,0c0.127-0.116,0.127-0.116,0.281-0.261l0,0l0,0c1.107-1.062,2.196-2.202,3.229-3.384c0.191-0.227,0.38-0.454,0.599-0.717 c0.186-0.23,0.345-0.431,0.502-0.63C116.243,72.807,116.296,72.774,116.862,72.406L116.862,72.406z M101.206,84.415 c-0.711,0.315-1.431,0.614-2.161,0.893c-0.299,0.083-0.481,0.135-1.027,0.276c1.186-0.592,2.332-1.252,3.518-2.012 c0.246-0.167,0.527-0.357,0.769-0.534c0.242-0.172,0.48-0.348,0.683-0.505c1.735-0.571,1.735-0.571,3.347-1.168 c-1.514,1.029-3.042,1.953-4.621,2.799L101.206,84.415L101.206,84.415z M92.919,87.128c-0.858,0.186-1.729,0.346-2.609,0.479 c0.111-0.047,0.245-0.095,0.348-0.141c0.12-0.05,0.242-0.103,0.359-0.153c1.266-0.169,1.266-0.169,2.524-0.368 C93.337,87.007,93.126,87.067,92.919,87.128L92.919,87.128z M87.954,87.89c-1.07,0.103-2.157,0.163-3.254,0.182l0.032-0.341 c2.236-0.071,2.236-0.071,4.429-0.224C88.766,87.654,88.357,87.78,87.954,87.89L87.954,87.89z M83.241,88.071 c-1.111-0.021-2.212-0.082-3.304-0.185h-0.002c-0.254-0.073-0.458-0.146-0.704-0.235c-0.122-0.043-0.246-0.089-0.367-0.137 c2.153,0.145,2.153,0.145,4.346,0.216C83.228,87.898,83.236,87.993,83.241,88.071L83.241,88.071z M77.734,87.617 c-0.928-0.137-1.847-0.305-2.753-0.504l-0.377-0.114c-0.081-0.024-0.081-0.024-0.164-0.05c1.263,0.2,1.263,0.2,2.568,0.374 C77.244,87.428,77.489,87.526,77.734,87.617L77.734,87.617z M68.944,85.321c-0.567-0.218-1.132-0.444-1.688-0.684 c-1.395-0.686-2.791-1.448-4.125-2.266c-0.355-0.229-0.711-0.464-0.996-0.657c-0.17-0.117-0.311-0.214-0.485-0.336 c1.642,0.617,1.642,0.617,3.346,1.166c1.306,0.953,2.636,1.801,3.979,2.541c0.266,0.141,0.531,0.276,0.802,0.409 c0.076,0.038,0.151,0.076,0.229,0.111C69.438,85.457,69.248,85.402,68.944,85.321L68.944,85.321z M58.157,79.274 c-2.589-1.998-4.948-4.285-7.02-6.816c0.571,0.369,0.621,0.399,1.309,0.788c0.983,1.223,1.995,2.373,3.048,3.478 c0.213,0.212,0.421,0.423,0.638,0.632c0.213,0.208,0.43,0.413,0.647,0.618l0,0l0,0l0,0c0.501,0.461,0.979,0.888,1.466,1.303l0,0 c0.065,0.056,0.065,0.056,0.131,0.109L58.157,79.274L58.157,79.274z M49.962,70.951c-0.207-0.276-0.412-0.56-0.614-0.842 c-1.392-2.1-2.661-4.313-3.797-6.638c-0.226-0.508-0.465-1.058-0.679-1.571c-0.177-0.435-0.347-0.876-0.514-1.314 c0.71,0.449,0.71,0.449,1.531,0.834c1.123,2.841,2.435,5.513,3.877,7.979c0.317,0.5,0.611,0.963,0.94,1.452l0,0 c0.212,0.317,0.456,0.661,0.701,1.008C50.65,71.419,50.623,71.4,49.962,70.951L49.962,70.951z M48.432,21.541l0.012-0.021 l0.015-0.023l0.014-0.024l0.014-0.02L48.5,21.43c0.475-0.719,0.968-1.423,1.483-2.112c0.639-0.418,0.666-0.434,1.449-0.906 c-1.552,2.263-2.973,4.699-4.22,7.267c-0.26,0.57-0.492,1.109-0.72,1.649c-0.204,0.502-0.399,1.008-0.591,1.516 c-0.833,0.425-0.833,0.425-1.543,0.875c1.065-2.663,2.329-5.238,3.734-7.641L48.432,21.541L48.432,21.541z M51.141,17.838 c2.085-2.543,4.454-4.842,7.056-6.844l0.21-0.106c-0.356,0.305-0.713,0.611-1.03,0.896l0,0c-0.161,0.142-0.161,0.142-0.286,0.257 l0,0c-0.158,0.144-0.158,0.144-0.281,0.261l0,0c0,0,0,0-0.031,0.027c-1.108,1.062-2.169,2.169-3.205,3.352l0,0 c-0.191,0.225-0.384,0.452-0.599,0.715c-0.186,0.229-0.347,0.429-0.5,0.628C51.759,17.443,51.708,17.473,51.141,17.838 L51.141,17.838z M66.77,5.878l0.019-0.008l0.015-0.007c0.721-0.321,1.457-0.622,2.193-0.903c0.291-0.079,0.477-0.127,1.009-0.266 C68.82,5.285,67.672,5.941,66.485,6.7c-0.249,0.167-0.53,0.358-0.771,0.532c-0.244,0.172-0.483,0.348-0.683,0.505 c-1.739,0.566-1.739,0.566-3.348,1.164c1.513-1.024,3.084-1.969,4.664-2.808L66.77,5.878L66.77,5.878z M75.041,3.173 c0.873-0.188,1.761-0.352,2.657-0.485c-0.109,0.042-0.233,0.09-0.33,0.136c-0.16,0.057-0.24,0.104-0.362,0.152 c-1.261,0.167-1.261,0.167-2.525,0.367L75.041,3.173L75.041,3.173z M80.032,2.408c1.059-0.1,2.129-0.157,3.209-0.177l-0.03,0.335 c-2.153,0.067-2.153,0.067-4.346,0.216C79.256,2.642,79.646,2.515,80.032,2.408L80.032,2.408z M95.818,4.212 c-1.79-0.331-1.79-0.331-3.628-0.606c0.08,0.038,0.116,0.071,0.195,0.109c0.151,0.099,0.298,0.201,0.49,0.311 c0.808,0.565,1.613,1.241,2.409,2.038c3.028,0.533,3.028,0.533,5.955,1.212c-0.138-0.095-0.278-0.196-0.416-0.292 c0.003,0,0.003,0,0.003,0c-0.278-0.191-0.561-0.378-0.847-0.561C98.608,5.573,97.218,4.837,95.818,4.212L95.818,4.212z  M90.44,3.397c-2.838-0.228-2.838-0.228-5.677-0.327c0.022,0.97,0.022,0.97,0.041,2.166c4.438,0.171,4.438,0.171,8.791,0.593 c-0.103-0.095-0.204-0.191-0.307-0.286c-0.165-0.167-0.34-0.322-0.475-0.453C92.034,4.41,91.213,3.845,90.44,3.397L90.44,3.397z  M83.217,3.07c-2.836,0.097-2.836,0.097-5.63,0.317c-0.159,0.074-0.276,0.147-0.392,0.221c-0.152,0.091-0.304,0.19-0.497,0.304 c-0.744,0.517-1.531,1.155-2.272,1.902c4.311-0.412,4.311-0.412,8.715-0.578C83.155,4.04,83.155,4.04,83.217,3.07L83.217,3.07z  M75.79,3.601c-1.838,0.276-1.838,0.276-3.625,0.605c-0.236,0.104-0.468,0.207-0.739,0.33c-0.272,0.128-0.541,0.257-0.848,0.404 C69.3,5.607,68.03,6.377,66.78,7.248c2.885-0.658,2.885-0.658,5.918-1.191c0.166-0.147,0.298-0.282,0.431-0.408 c0.17-0.159,0.301-0.302,0.474-0.448C74.338,4.574,75.07,4.044,75.79,3.601L75.79,3.601z M108.031,10.208 c-1.76-0.69-1.76-0.69-3.657-1.327c0.059,0.06,0.059,0.06,0.156,0.137V9.02c0.443,0.389,0.878,0.79,1.335,1.222 c0,0.002,0,0.002,0,0.002l0,0l0,0c0.177,0.183,0.388,0.383,0.562,0.562c0.175,0.181,0.346,0.366,0.549,0.579 c0.925,1.013,1.82,2.097,2.685,3.251c2.478,0.858,2.478,0.858,4.688,1.813c-0.08-0.097-0.133-0.164-0.209-0.261 c-0.218-0.257-0.382-0.45-0.543-0.642l0,0c-0.947-1.07-1.906-2.078-2.872-3.019l0,0c-0.005,0-0.005,0-0.036-0.025l0,0 c-0.121-0.119-0.245-0.232-0.368-0.347c-0.093-0.084-0.222-0.2-0.375-0.342C109.306,11.254,108.693,10.736,108.031,10.208 L108.031,10.208z M102.672,8.384c-3.152-0.746-3.152-0.746-6.509-1.352c0.055,0.083,0.055,0.083,0.149,0.18l0,0 c0.299,0.368,0.578,0.748,0.889,1.156c0,0,0,0,0,0.002c0,0,0,0,0,0.002l0,0c0.108,0.16,0.211,0.325,0.35,0.509 c0.128,0.195,0.227,0.366,0.364,0.543l0,0c0.567,0.919,1.108,1.916,1.681,3.023c4.486,0.776,4.486,0.776,8.589,1.752 c-0.075-0.098-0.146-0.198-0.217-0.296c-0.176-0.223-0.327-0.42-0.477-0.615c-0.859-1.046-1.713-2.001-2.585-2.888 c0.005,0,0.005,0,0.005,0s0,0,0-0.003l0,0c-0.185-0.169-0.185-0.169-0.33-0.317l0,0c-0.148-0.147-0.148-0.147-0.335-0.315l0,0 C103.725,9.283,103.226,8.835,102.672,8.384L102.672,8.384z M94.457,6.788c-4.746-0.466-4.746-0.466-9.634-0.658 c0.02,2.395,0.02,2.395,0.055,5.239c6.604,0.234,6.604,0.234,12.981,0.836c-0.078-0.177-0.078-0.177-0.162-0.353 c-0.102-0.22-0.213-0.427-0.331-0.622c-0.521-0.994-1.063-1.912-1.625-2.754c0,0,0,0,0-0.001V8.475 c-0.115-0.144-0.115-0.144-0.193-0.275l0,0c-0.119-0.141-0.119-0.141-0.201-0.27l0,0C95.061,7.531,94.766,7.152,94.457,6.788 L94.457,6.788z M83.121,6.13c-4.849,0.187-4.849,0.187-9.598,0.65c-0.026,0.056-0.026,0.056-0.088,0.12l0,0 c-0.091,0.116-0.091,0.116-0.182,0.235c-0.328,0.41-0.642,0.85-0.975,1.322l0,0c0,0.002,0,0.002,0,0.003l0,0 c-0.106,0.163-0.252,0.337-0.319,0.486c-0.143,0.177-0.245,0.345-0.344,0.519c0,0.001,0,0.001,0,0.001 c-0.526,0.853-1.003,1.756-1.497,2.731c6.347-0.596,6.347-0.596,12.949-0.829C83.103,8.524,83.103,8.524,83.121,6.13L83.121,6.13z  M71.858,7.012c-3.364,0.601-3.364,0.601-6.551,1.36c-0.095,0.085-0.095,0.085-0.225,0.19l0,0c-0.13,0.104-0.227,0.189-0.324,0.273 c-0.566,0.491-1.119,1.002-1.652,1.53c0,0,0,0-0.035,0.022v0.001c-0.143,0.15-0.323,0.326-0.492,0.508 c-0.175,0.177-0.346,0.358-0.512,0.542c-0.769,0.857-1.531,1.775-2.276,2.748c4.1-0.977,4.1-0.977,8.623-1.766 c0.122-0.254,0.122-0.254,0.242-0.505c0.102-0.215,0.242-0.443,0.347-0.655c0.595-1.07,1.19-2.035,1.811-2.916l0,0l0,0 c0-0.002,0-0.002,0-0.002c0.079-0.116,0.079-0.116,0.163-0.233l0,0c0.085-0.116,0.085-0.116,0.167-0.231 C71.375,7.58,71.614,7.289,71.858,7.012L71.858,7.012z M63.644,8.849c-1.9,0.633-1.9,0.633-3.698,1.343 c-0.097,0.079-0.196,0.159-0.296,0.24c0,0,0,0,0-0.001c-0.13,0.106-0.265,0.213-0.394,0.322c-0.683,0.569-1.316,1.13-1.965,1.734 l0,0l0,0c-0.183,0.174-0.366,0.352-0.579,0.557c-0.209,0.207-0.389,0.387-0.565,0.568c-0.875,0.911-1.716,1.85-2.52,2.82 c2.209-0.952,2.209-0.952,4.687-1.811c0.144-0.199,0.292-0.396,0.449-0.588c0.172-0.228,0.353-0.455,0.529-0.682 c0.923-1.123,1.882-2.169,2.857-3.142l0,0l0,0l0,0c0.121-0.12,0.121-0.12,0.242-0.237l0,0c0.155-0.137,0.155-0.137,0.276-0.254l0,0 C62.977,9.431,63.29,9.146,63.644,8.849L63.644,8.849z M115.451,17.872c-2.244-0.96-2.244-0.96-4.804-1.834 c0.226,0.339,0.439,0.68,0.679,1.054c0.295,0.481,0.584,0.966,0.861,1.452c1.392,2.566,2.657,5.403,3.71,8.432 c2.927,0.724,2.927,0.724,5.333,1.534c-0.174-0.46-0.356-0.919-0.541-1.377c-0.244-0.57-0.475-1.1-0.73-1.661 C118.625,22.754,117.115,20.219,115.451,17.872L115.451,17.872z M109.192,15.614c-4.246-0.988-4.246-0.988-8.968-1.797 c0.171,0.362,0.325,0.728,0.479,1.099c0.199,0.485,0.383,0.976,0.561,1.469c0.938,2.631,1.794,5.586,2.51,8.819 c5.768,0.671,5.768,0.671,10.799,1.497c-0.164-0.492-0.349-1.014-0.526-1.504c-0.237-0.627-0.47-1.22-0.694-1.782 C112.117,20.564,110.707,17.948,109.192,15.614L109.192,15.614z M98.511,13.597c-6.662-0.615-6.662-0.615-13.604-0.858 c0.032,5.407,0.032,5.407,0.063,11.593c8.73,0.201,8.73,0.201,17.021,0.718c-0.129-0.591-0.247-1.135-0.362-1.65 c-0.131-0.601-0.292-1.234-0.461-1.878C100.361,18.551,99.477,15.911,98.511,13.597L98.511,13.597z M83.043,12.739 c-6.911,0.233-6.911,0.233-13.548,0.834c-0.188,0.406-0.34,0.801-0.519,1.21c-0.178,0.464-0.37,0.962-0.548,1.47 C67.52,18.859,66.693,21.795,66,25.02c8.244-0.493,8.244-0.493,16.963-0.688C82.981,18.145,82.981,18.145,83.043,12.739 L83.043,12.739z M67.752,13.808c-4.692,0.785-4.692,0.785-8.969,1.793c-0.266,0.399-0.527,0.807-0.809,1.24 c-0.29,0.479-0.6,0.983-0.872,1.464c-1.375,2.525-2.638,5.345-3.704,8.378c5.05-0.845,5.05-0.845,10.814-1.509 c0.106-0.542,0.237-1.114,0.373-1.694c0.159-0.662,0.322-1.291,0.472-1.869C65.875,18.706,66.784,16.1,67.752,13.808L67.752,13.808 z M57.33,16.023c-2.559,0.871-2.559,0.871-4.805,1.83c-0.323,0.437-0.616,0.845-0.899,1.257c-0.33,0.481-0.647,0.969-0.962,1.461 c-1.475,2.458-2.804,5.123-3.926,7.917c2.412-0.81,2.412-0.81,5.335-1.533c0.179-0.534,0.366-1.071,0.579-1.637 c0.209-0.574,0.451-1.179,0.683-1.749c0,0,0,0,0-0.002C54.533,20.813,55.881,18.292,57.33,16.023L57.33,16.023z M124.136,31.235 c-0.7-0.428-0.7-0.428-1.534-0.833c0.191,0.594,0.375,1.191,0.548,1.79c0.183,0.641,0.349,1.286,0.506,1.931l0,0 c0.701,3.284,1.136,6.693,1.282,10.245c0.802,0.028,0.802,0.028,1.436,0.058c-0.018-0.641-0.04-1.281-0.073-1.922 c-0.043-0.639-0.095-1.278-0.162-1.961C125.711,37.32,125.039,34.225,124.136,31.235L124.136,31.235z M121.799,30.095 c-2.417-0.759-2.417-0.759-5.375-1.441c0.183,0.643,0.371,1.319,0.545,1.999c0.177,0.711,0.342,1.423,0.503,2.169 c0.699,3.635,1.134,7.48,1.257,11.418c3.075,0.073,3.075,0.073,5.496,0.101c-0.016-0.69-0.041-1.379-0.079-2.069 c-0.044-0.731-0.104-1.418-0.176-2.145C123.525,36.651,122.778,33.262,121.799,30.095L121.799,30.095z M115.107,28.407 c-5.113-0.783-5.113-0.783-10.979-1.402c0.021,0.089,0.021,0.089,0.027,0.157c0.138,0.731,0.27,1.486,0.382,2.26 c0.129,0.802,0.243,1.591,0.349,2.361c0.466,3.899,0.753,8.045,0.837,12.357c6.315,0.049,6.315,0.049,11.729,0.099 c-0.013-0.81-0.043-1.623-0.083-2.433c-0.043-0.779-0.104-1.59-0.171-2.373C116.767,35.537,116.061,31.854,115.107,28.407 L115.107,28.407z M102.341,26.867c-8.465-0.486-8.465-0.486-17.369-0.665c0.015,8.71,0.015,8.71,0.02,17.882 c9.728,0.014,9.728,0.014,18.906,0.042c0-0.123,0-0.123,0-0.263c-0.01-0.889-0.03-1.765-0.062-2.667 c-0.03-0.853-0.074-1.74-0.121-2.597C103.44,34.456,102.962,30.509,102.341,26.867L102.341,26.867z M82.942,26.201 c-8.874,0.173-8.874,0.173-17.299,0.638c-0.023,0.118-0.023,0.118-0.049,0.239c-0.132,0.759-0.251,1.504-0.368,2.253 c-0.123,0.754-0.235,1.545-0.343,2.374c-0.461,3.931-0.744,8.092-0.825,12.409c9.147-0.026,9.147-0.026,18.839-0.03 C82.918,34.912,82.918,34.912,82.942,26.201L82.942,26.201z M63.843,26.993c-5.867,0.614-5.867,0.614-10.966,1.364 c-0.012,0.033-0.012,0.033-0.012,0.034l0,0c-0.201,0.695-0.39,1.39-0.584,2.117c-0.179,0.724-0.346,1.452-0.502,2.174 c-0.703,3.655-1.148,7.538-1.271,11.505c5.417-0.042,5.417-0.042,11.729-0.058c0-0.132,0-0.132,0.004-0.285 c0.013-0.882,0.036-1.768,0.064-2.638c0.035-0.88,0.078-1.746,0.128-2.6C62.729,34.493,63.201,30.61,63.843,26.993L63.843,26.993z  M51.544,28.635c-2.956,0.681-2.956,0.681-5.371,1.438c-0.207,0.624-0.405,1.248-0.588,1.879c-0.188,0.669-0.369,1.338-0.522,1.974 c-0.731,3.347-1.182,6.819-1.327,10.392c2.421-0.065,2.421-0.065,5.495-0.096l0,0c0.014-0.808,0.045-1.616,0.085-2.42 c0.045-0.809,0.104-1.582,0.175-2.354C49.91,35.657,50.607,32.036,51.544,28.635L51.544,28.635z M45.368,30.379 c-0.838,0.405-0.838,0.405-1.521,0.792c-0.203,0.61-0.379,1.181-0.558,1.798c-0.173,0.617-0.337,1.237-0.482,1.82 c-0.657,3.097-1.065,6.278-1.219,9.569c0.633-0.03,0.633-0.03,1.433-0.057c0.015-0.66,0.043-1.363,0.085-2.064 c0.041-0.701,0.102-1.401,0.172-2.101C43.711,36.768,44.427,33.484,45.368,30.379L45.368,30.379z M72.165,86.093 c1.793,0.33,1.793,0.33,3.625,0.603c-0.073-0.05-0.073-0.05-0.189-0.109l0,0c-0.156-0.092-0.306-0.191-0.494-0.313 c-0.809-0.563-1.616-1.239-2.405-2.034c-3.035-0.532-3.035-0.532-5.959-1.205c0.141,0.095,0.276,0.193,0.414,0.292 c0.28,0.192,0.558,0.38,0.806,0.542C69.376,84.737,70.766,85.47,72.165,86.093L72.165,86.093z M77.546,86.903 c2.835,0.227,2.835,0.227,5.671,0.322c-0.063-0.972-0.063-0.972-0.076-2.17c-4.401-0.167-4.401-0.167-8.753-0.584 c0.103,0.098,0.202,0.193,0.304,0.287c0.133,0.142,0.309,0.297,0.48,0.454l0,0C75.952,85.888,76.773,86.455,77.546,86.903 L77.546,86.903z M84.764,87.225c2.839-0.097,2.839-0.097,5.677-0.324c0.114-0.07,0.272-0.148,0.388-0.224 c0.153-0.091,0.304-0.191,0.497-0.305c0.744-0.52,1.491-1.15,2.271-1.908c-4.353,0.421-4.353,0.421-8.791,0.592 C84.786,86.254,84.786,86.254,84.764,87.225L84.764,87.225z M92.19,86.692c1.465-0.224,3.06-0.313,4.406-0.95 c0.271-0.125,0.54-0.257,0.844-0.404c1.277-0.669,2.546-1.441,3.795-2.315c-2.883,0.662-2.883,0.662-5.953,1.208 c-0.129,0.139-0.261,0.271-0.396,0.4c-0.164,0.163-0.335,0.318-0.467,0.448l0,0C93.684,85.706,92.953,86.239,92.19,86.692 L92.19,86.692z M59.946,80.11c1.767,0.687,1.767,0.687,3.667,1.319c-0.065-0.056-0.065-0.056-0.163-0.136v-0.001 c-0.447-0.387-0.877-0.788-1.301-1.197c0,0,0,0,0.003,0l0,0c-0.212-0.203-0.392-0.383-0.563-0.563 c-0.214-0.203-0.384-0.389-0.586-0.6c-0.923-1.013-1.82-2.101-2.715-3.28c-2.478-0.857-2.478-0.857-4.654-1.78 c0.104,0.129,0.104,0.129,0.209,0.26c0.214,0.257,0.375,0.453,0.539,0.642c0.947,1.072,1.908,2.077,2.909,3.044l0,0l0,0l0,0 c0.152,0.146,0.276,0.26,0.369,0.346c0.187,0.171,0.187,0.171,0.376,0.342l0,0C58.671,79.065,59.285,79.58,59.946,80.11 L59.946,80.11z M65.31,81.926c3.15,0.743,3.15,0.743,6.514,1.344c-0.059-0.083-0.059-0.083-0.151-0.179l0,0 c-0.297-0.363-0.58-0.743-0.857-1.134c0,0,0,0,0-0.004c0,0,0,0,0.003,0l0,0c-0.146-0.174-0.25-0.339-0.352-0.512 c-0.134-0.186-0.267-0.371-0.364-0.542c-0.601-0.937-1.141-1.936-1.716-3.046c-4.486-0.771-4.486-0.771-8.619-1.766 c0.123,0.16,0.123,0.16,0.248,0.322c0,0.001,0,0.001,0,0.001c0.176,0.223,0.322,0.418,0.476,0.613 c0.858,1.047,1.71,2.003,2.617,2.912c0,0.002,0,0.002,0,0.002l0,0l0,0c0.145,0.148,0.145,0.148,0.294,0.296 c0.152,0.138,0.243,0.23,0.333,0.313C64.258,81.028,64.757,81.476,65.31,81.926L65.31,81.926z M73.524,83.512 c4.748,0.462,4.748,0.462,9.596,0.648c-0.018-2.396-0.018-2.396-0.049-5.244c-6.606-0.23-6.606-0.23-12.948-0.821 c0.081,0.178,0.081,0.178,0.161,0.354c0.1,0.219,0.214,0.429,0.332,0.621c0.521,0.999,1.097,1.934,1.66,2.773v0.002 c0,0.001,0,0.001,0,0.001c0.077,0.132,0.077,0.132,0.195,0.273l0,0c0.08,0.13,0.08,0.13,0.161,0.258l0,0 C72.957,82.787,73.256,83.166,73.524,83.512L73.524,83.512z M84.823,84.158c4.888-0.188,4.888-0.188,9.634-0.653 c0.064-0.064,0.064-0.064,0.128-0.13l0,0c0.088-0.113,0.088-0.113,0.177-0.23c0.332-0.41,0.643-0.846,0.979-1.317l0,0 c0,0,0,0,0-0.002v-0.001c0.106-0.166,0.214-0.326,0.317-0.489c0.11-0.152,0.211-0.321,0.341-0.52 c0.489-0.843,0.997-1.762,1.487-2.744c-6.377,0.604-6.377,0.604-13.012,0.845C84.843,81.764,84.843,81.764,84.823,84.158 L84.823,84.158z M96.158,83.263c3.359-0.604,3.359-0.604,6.55-1.366c0.094-0.083,0.094-0.083,0.227-0.188l0,0 c0.158-0.135,0.158-0.135,0.318-0.274l0,0c0.568-0.49,1.121-1.001,1.658-1.529c-0.005,0-0.005,0-0.005-0.001 c0.145-0.152,0.323-0.328,0.527-0.531c0,0,0,0,0,0.001c0.14-0.153,0.313-0.336,0.478-0.521c0,0,0,0,0-0.003 c0.799-0.88,1.558-1.801,2.297-2.776c-4.095,0.978-4.095,0.978-8.617,1.771c-0.121,0.255-0.121,0.255-0.24,0.51 c-0.135,0.231-0.242,0.444-0.348,0.658l0,0c-0.591,1.072-1.219,2.058-1.802,2.925c0,0,0,0-0.033,0.013c0,0,0,0,0,0.001 c0,0,0,0,0,0.002c-0.083,0.115-0.083,0.115-0.166,0.232l0,0c-0.082,0.114-0.082,0.114-0.171,0.228 C96.603,82.709,96.399,82.985,96.158,83.263L96.158,83.263z M104.37,81.419c1.897-0.638,1.897-0.638,3.696-1.348 c0.13-0.106,0.13-0.106,0.297-0.238l0,0c0.196-0.16,0.196-0.16,0.396-0.32c0.646-0.546,1.313-1.134,1.929-1.712 c0.036-0.025,0.036-0.025,0.036-0.025c-0.005-0.002-0.005-0.002-0.005-0.002c0.156-0.146,0.366-0.351,0.577-0.558c0,0,0,0,0.003,0 c0.178-0.179,0.384-0.385,0.563-0.566c0.842-0.883,1.684-1.825,2.511-2.827c-2.205,0.956-2.205,0.956-4.683,1.815 c-0.145,0.2-0.293,0.397-0.445,0.59c-0.146,0.199-0.319,0.428-0.532,0.684c-0.917,1.127-1.871,2.175-2.847,3.149l0,0 c0,0.001,0,0.001-0.033,0.023l0,0c-0.122,0.118-0.122,0.118-0.243,0.234c0,0,0,0,0,0.002c-0.122,0.116-0.122,0.116-0.241,0.23l0,0 C105.035,80.837,104.685,81.141,104.37,81.419L104.37,81.419z M52.5,72.418c2.273,0.988,2.273,0.988,4.833,1.86 c-0.225-0.34-0.443-0.681-0.679-1.057c-0.296-0.481-0.583-0.962-0.864-1.447c-1.392-2.567-2.66-5.403-3.716-8.429 c-2.943-0.757-2.943-0.757-5.35-1.568c0.189,0.5,0.372,0.959,0.562,1.417c0.221,0.531,0.471,1.097,0.729,1.658 C49.327,67.531,50.833,70.069,52.5,72.418L52.5,72.418z M58.786,74.697c4.25,0.985,4.25,0.985,8.971,1.789 c-0.168-0.363-0.326-0.731-0.474-1.103c-0.199-0.486-0.389-0.975-0.565-1.469c-0.961-2.647-1.793-5.584-2.513-8.813 c-5.769-0.667-5.769-0.667-10.802-1.482c0.179,0.522,0.346,1.012,0.527,1.501c0.216,0.595,0.45,1.188,0.695,1.78 C55.862,69.753,57.245,72.341,58.786,74.697L58.786,74.697z M69.473,76.703c6.662,0.61,6.662,0.61,13.57,0.842 c-0.063-5.41-0.063-5.41-0.08-11.597c-8.708-0.189-8.708-0.189-16.974-0.693c0.115,0.572,0.247,1.133,0.365,1.646 c0.131,0.602,0.291,1.235,0.438,1.862C67.594,71.73,68.507,74.39,69.473,76.703L69.473,76.703z M84.904,77.545 c6.938-0.239,6.938-0.239,13.603-0.85c0.188-0.408,0.339-0.804,0.517-1.214c0.18-0.466,0.368-0.96,0.543-1.469 c0.907-2.607,1.729-5.544,2.414-8.77c-8.29,0.509-8.29,0.509-17.015,0.705C84.938,72.135,84.938,72.135,84.904,77.545 L84.904,77.545z M100.25,76.459c4.69-0.791,4.69-0.791,8.969-1.802c0.265-0.4,0.525-0.806,0.805-1.242 c0.289-0.478,0.599-0.982,0.873-1.462c1.367-2.529,2.626-5.35,3.687-8.383c-5.05,0.853-5.05,0.853-10.797,1.501 c-0.123,0.56-0.254,1.129-0.386,1.71c-0.161,0.665-0.321,1.295-0.472,1.873C102.117,71.559,101.214,74.162,100.25,76.459 L100.25,76.459z M110.674,74.233c2.557-0.875,2.557-0.875,4.804-1.835c0.321-0.437,0.61-0.844,0.896-1.257 c0.327-0.482,0.646-0.971,0.964-1.464c1.463-2.46,2.791-5.126,3.909-7.924c-2.408,0.815-2.408,0.815-5.331,1.539 c-0.183,0.536-0.369,1.073-0.581,1.643c-0.225,0.606-0.444,1.181-0.677,1.746C113.458,69.441,112.117,71.962,110.674,74.233 L110.674,74.233z M43.829,59.094c0.701,0.426,0.701,0.426,1.523,0.793c-0.181-0.555-0.363-1.152-0.536-1.752 c-0.18-0.64-0.348-1.283-0.505-1.928c-0.702-3.284-1.144-6.736-1.291-10.246c-0.804-0.026-0.804-0.026-1.433-0.057 c0.013,0.641,0.042,1.282,0.075,1.921c0.039,0.642,0.095,1.323,0.159,1.961C42.251,53.01,42.923,56.104,43.829,59.094 L43.829,59.094z M46.173,60.231c2.415,0.757,2.415,0.757,5.376,1.435c-0.2-0.675-0.387-1.353-0.56-2.03 c-0.178-0.712-0.342-1.422-0.503-2.169c-0.703-3.634-1.127-7.445-1.258-11.418c-3.076-0.035-3.076-0.035-5.494-0.062 c0.015,0.69,0.042,1.382,0.08,2.069c0.048,0.729,0.105,1.418,0.179,2.146C44.441,53.676,45.177,57.025,46.173,60.231L46.173,60.231 z M52.866,61.912c5.117,0.778,5.117,0.778,10.966,1.37c-0.014-0.095-0.014-0.095-0.033-0.187c-0.125-0.711-0.252-1.463-0.384-2.258 c-0.125-0.803-0.229-1.569-0.331-2.34c-0.475-3.911-0.763-8.034-0.847-12.344c-6.313-0.023-6.313-0.023-11.729-0.071l0,0 c0.015,0.811,0.043,1.622,0.083,2.433c0.046,0.78,0.106,1.593,0.175,2.37C51.19,54.753,51.909,58.468,52.866,61.912L52.866,61.912z  M65.639,63.438c8.422,0.464,8.422,0.464,17.303,0.641c-0.029-8.714-0.029-8.714-0.044-17.888 c-9.695-0.009-9.695-0.009-18.839-0.021c0.002,0.14,0.002,0.14,0.008,0.301c0.007,0.869,0.028,1.766,0.06,2.647 c0.034,0.875,0.071,1.739,0.125,2.616C64.527,55.858,65.001,59.783,65.639,63.438L65.639,63.438z M84.972,64.078 c8.916-0.186,8.916-0.186,17.377-0.671c0.023-0.125,0.023-0.125,0.042-0.247c0.131-0.761,0.265-1.525,0.379-2.274 c0.103-0.731,0.217-1.523,0.318-2.35c0.457-3.925,0.739-8.082,0.813-12.4c-9.179,0.036-9.179,0.036-18.91,0.055 C84.984,55.364,84.984,55.364,84.972,64.078L84.972,64.078z M104.137,63.271c5.866-0.621,5.866-0.621,10.981-1.41 c-0.001,0-0.001,0-0.005-0.001l0,0c0.22-0.727,0.404-1.422,0.578-2.116c0.183-0.728,0.347-1.452,0.502-2.178 c0.7-3.654,1.138-7.537,1.259-11.536c-5.413,0.057-5.413,0.057-11.729,0.109c-0.005,0.154-0.005,0.154-0.005,0.287 c-0.013,0.904-0.033,1.789-0.062,2.659c-0.034,0.879-0.078,1.747-0.129,2.601C105.245,55.775,104.775,59.655,104.137,63.271 L104.137,63.271z M116.435,61.614c2.96-0.684,2.96-0.684,5.375-1.445c0.207-0.623,0.397-1.249,0.583-1.878 c0.189-0.669,0.366-1.34,0.523-1.977c0.727-3.346,1.17-6.817,1.312-10.392c-2.424,0.068-2.424,0.068-5.499,0.106l0,0 c-0.014,0.841-0.04,1.613-0.078,2.418c-0.047,0.809-0.102,1.581-0.174,2.355C118.064,54.591,117.369,58.212,116.435,61.614 L116.435,61.614z M122.614,59.861c0.837-0.404,0.837-0.404,1.521-0.791c0.199-0.613,0.377-1.184,0.557-1.801 c0.171-0.618,0.323-1.197,0.474-1.82c0.654-3.097,1.063-6.281,1.207-9.572c-0.634,0.032-0.634,0.032-1.436,0.062 c-0.012,0.701-0.038,1.36-0.076,2.063c-0.045,0.699-0.101,1.401-0.173,2.102C124.262,53.47,123.555,56.757,122.614,59.861 L122.614,59.861z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3C717",
    d: "M124.735,31.084c11.966,0,15.935,20.869,15.935,20.869c2.042,6.602-2.854,6.547-2.854,6.547H84.052 h-0.203H30.083c0,0-4.837,0.055-2.711-6.547c0,0,4.174-20.976,16.283-20.976L124.735,31.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3C717",
    d: "M83.849,57.5h53.985c0.147,0,1.471,0.133,2.233-0.9c0.713-0.967,0.742-2.516,0.087-4.634l-0.015-0.019 c-0.038-0.205-4.023-20.344-15.404-20.344l-81.082-0.13c-11.525,0-15.711,20.308-15.752,20.512l-0.015,0.063 c-0.688,2.138-0.682,3.614,0.02,4.578c0.733,1.006,2.014,0.873,2.159,0.873H83.849z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M38.519,48.048V41.42h-1.458v-1.588h5.143v1.588h-1.457v6.628H38.519z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M42.228,48.048l1.824-8.216h2.997l1.801,8.216h-2.378l-0.224-1.478h-1.541l-0.223,1.478H42.228z  M44.965,45.08h1.073l-0.506-3.915l-0.085,0.686l-0.103,0.731L44.965,45.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M48.626,48.048l1.938-4.404l-1.799-3.813h2.449l0.494,1.459c0.104,0.282,0.187,0.584,0.247,0.9 c0.039-0.2,0.083-0.381,0.126-0.541c0.052-0.173,0.104-0.332,0.156-0.476l0.506-1.343h2.364l-1.858,3.813l1.974,4.404h-2.432 l-0.65-1.784l-0.144-0.476l-0.103-0.486c-0.028,0.184-0.105,0.474-0.235,0.868l-0.025,0.074l-0.63,1.804H48.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M55.556,48.048v-8.216h2.233v8.216H55.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M59.979,48.048l-1.685-8.216h2.343l0.432,3.397c0.016,0.137,0.054,0.441,0.115,0.912 c0.027,0.213,0.063,0.515,0.106,0.906l0.11,0.982c0-0.211,0.021-0.503,0.067-0.877c0.016-0.214,0.038-0.485,0.064-0.812 l0.127-1.207l0.458-3.302h2.215l0.446,3.262l0.106,1.175l0.139,1.754c0-0.229,0.015-0.487,0.042-0.771 c0.016-0.174,0.055-0.467,0.114-0.881l0.632-4.54h2.281l-1.69,8.216h-2.541l-0.542-4.399l-0.095-1.438 c0,0.184-0.019,0.418-0.059,0.701l-0.075,0.455l-0.151,1.224l-0.456,3.456H59.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M68.467,42.25c0-1.688,0.981-2.535,2.944-2.535c1.959,0,2.939,0.846,2.939,2.535v3.378 c0,1.695-0.979,2.545-2.939,2.545c-1.962,0-2.944-0.85-2.944-2.545V42.25z M70.725,41.95v3.983c0,0.508,0.229,0.762,0.686,0.762 c0.454,0,0.681-0.254,0.681-0.762V41.95c0-0.511-0.232-0.766-0.692-0.766C70.95,41.184,70.725,41.439,70.725,41.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M75.387,48.048v-8.216h3.196c1.656,0,2.484,0.611,2.484,1.835v0.47c0,0.791-0.404,1.318-1.215,1.582 c0.811,0.211,1.215,0.73,1.215,1.559v1.898c0,0.381,0.071,0.672,0.213,0.872h-2.258c-0.104-0.168-0.157-0.481-0.157-0.941v-1.583 c0-0.425-0.085-0.711-0.255-0.858c-0.171-0.146-0.509-0.221-1.014-0.221v3.603H75.387z M77.595,43.144 c0.465,0,0.8-0.058,1.005-0.176c0.176-0.1,0.264-0.283,0.264-0.55V41.95c0-0.3-0.112-0.504-0.336-0.61 c-0.166-0.077-0.448-0.116-0.85-0.116h-0.083V43.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M82.152,48.048v-8.216h2.232v6.602h2.438v1.614H82.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M87.468,39.832h2.765c1.112,0,1.879,0.139,2.304,0.417c0.487,0.317,0.728,0.92,0.728,1.809v3.776 c0,0.819-0.269,1.409-0.812,1.772c-0.232,0.158-0.524,0.271-0.878,0.342c-0.167,0.033-0.391,0.059-0.676,0.075 c-0.283,0.017-0.639,0.025-1.064,0.025h-2.366V39.832z M89.983,41.234h-0.282v5.404h0.282c0.397,0,0.664-0.043,0.802-0.135 c0.148-0.103,0.223-0.313,0.223-0.632v-3.866c0-0.321-0.074-0.532-0.223-0.636C90.652,41.279,90.387,41.234,89.983,41.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M98.867,40.294h-1.843v-0.451h4.314v0.451h-1.841v7.753h-0.631V40.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M103.122,39.843v5.599c0,1.655,0.702,2.228,1.595,2.228c1.009,0,1.638-0.658,1.638-2.228v-5.599h0.63 v5.539c0,2.144-1.111,2.763-2.297,2.763c-1.126,0-2.194-0.571-2.194-2.593v-5.708H103.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M108.796,39.964c0.394-0.121,0.876-0.157,1.33-0.157c0.921,0,1.521,0.194,1.96,0.571 c0.426,0.377,0.644,0.926,0.644,1.535c0,1.156-0.644,1.777-1.623,2.155v0.025c0.759,0.158,1.17,0.778,1.405,1.97 c0.246,1.256,0.407,1.754,0.525,1.985h-0.63c-0.146-0.257-0.321-0.999-0.542-2.07c-0.249-1.192-0.744-1.691-1.9-1.691h-0.541 v3.762h-0.628V39.964z M109.424,43.872h0.555c1.215,0,2.093-0.718,2.093-1.862c0-1.095-0.541-1.753-1.975-1.753 c-0.263,0-0.497,0.013-0.673,0.048V43.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M114.219,39.843h0.628v4.029h0.03c0.263-0.34,0.482-0.657,0.687-0.948l2.164-3.081h0.717l-2.544,3.458 l2.634,4.747h-0.69l-2.367-4.297l-0.63,0.853v3.445h-0.628V39.843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M122.875,43.971h-2.603v3.614h2.983v0.463h-3.613v-8.205h3.422v0.462h-2.792v3.202h2.603V43.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000119",
    d: "M126.28,48.048v-3.677l-2.18-4.528h0.673l0.994,2.119c0.28,0.597,0.601,1.267,0.864,1.923h0.03 c0.247-0.657,0.568-1.303,0.877-1.96l0.993-2.082h0.674l-2.297,4.504v3.701H126.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.999,
    y: 34.371,
    transform: "matrix(0.0028 -1 1 0.0028 11.5043 82.7012)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.583,
    y: 31.924,
    transform: "matrix(0.0028 -1 1 0.0028 11.5426 77.8445)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.153,
    y: 34.357,
    transform: "matrix(0.0026 -1 1 0.0026 6.6949 77.8495)",
    fill: "#000119",
    width: 2.441,
    height: 2.423
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.691,
    y: 34.396,
    transform: "matrix(0.0026 -1 1 0.0026 21.1546 92.427)",
    fill: "#000119",
    width: 2.44,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.274,
    y: 31.95,
    transform: "matrix(0.0026 -1 1 0.0026 21.1921 87.5696)",
    fill: "#000119",
    width: 2.441,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.844,
    y: 34.383,
    transform: "matrix(0.0028 -1 1 0.0028 16.3241 87.5598)",
    fill: "#000119",
    width: 2.441,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.428,
    y: 31.937,
    transform: "matrix(0.0026 -1 1 0.0026 16.3705 82.71)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.999,
    y: 34.371,
    transform: "matrix(0.0028 -1 1 0.0028 11.5043 82.7012)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.381,
    y: 34.423,
    transform: "matrix(0.0024 -1 1 0.0024 30.8071 102.1511)",
    fill: "#000119",
    width: 2.441,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.966,
    y: 31.977,
    transform: "matrix(0.0026 -1 1 0.0026 30.8302 97.2875)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.536,
    y: 34.411,
    transform: "matrix(0.0026 -1 1 0.0026 25.973 97.2853)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.121,
    y: 31.964,
    transform: "matrix(0.003 -1 1 0.003 25.9878 92.4155)",
    fill: "#000119",
    width: 2.44,
    height: 2.421
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.691,
    y: 34.396,
    transform: "matrix(0.0026 -1 1 0.0026 21.1546 92.427)",
    fill: "#000119",
    width: 2.44,
    height: 2.424
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.074,
    y: 34.451,
    transform: "matrix(0.0026 -1 1 0.0026 40.434 111.864)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.658,
    y: 32.003,
    transform: "matrix(0.0026 -1 1 0.0026 40.471 107.0061)",
    fill: "#000119",
    width: 2.44,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.228,
    y: 34.437,
    transform: "matrix(0.0028 -1 1 0.0028 35.5991 106.9963)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.811,
    y: 31.99,
    transform: "matrix(0.003 -1 1 0.003 35.6236 102.133)",
    fill: "#000119",
    width: 2.441,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.381,
    y: 34.423,
    transform: "matrix(0.0024 -1 1 0.0024 30.8071 102.1511)",
    fill: "#000119",
    width: 2.441,
    height: 2.424
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.767,
    y: 34.477,
    transform: "matrix(0.0032 -1 1 0.0032 50.023 121.5608)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.35,
    y: 32.03,
    transform: "matrix(0.0024 -1 1 0.0024 50.1289 116.7318)",
    fill: "#000119",
    width: 2.441,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.92,
    y: 34.463,
    transform: "matrix(0.0028 -1 1 0.0028 45.2385 116.7155)",
    fill: "#000119",
    width: 2.441,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.504,
    y: 32.017,
    transform: "matrix(0.0028 -1 1 0.0028 45.2749 111.859)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.074,
    y: 34.451,
    transform: "matrix(0.0026 -1 1 0.0026 40.434 111.864)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.429,
    y: 34.504,
    transform: "matrix(0.0028 -1 1 0.0028 59.6667 131.2641)",
    fill: "#000119",
    width: 2.441,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.014,
    y: 32.058,
    transform: "matrix(0.0024 -1 1 0.0024 59.7413 126.4225)",
    fill: "#000119",
    width: 2.44,
    height: 2.421
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.585,
    y: 34.49,
    transform: "matrix(0.0028 -1 1 0.0028 54.8478 126.4069)",
    fill: "#000119",
    width: 2.44,
    height: 2.425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.168,
    y: 32.044,
    transform: "matrix(0.0028 -1 1 0.0028 54.8858 121.5495)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.739,
    y: 34.478,
    transform: "matrix(0.0032 -1 1 0.0032 49.9953 121.533)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.121,
    y: 34.531,
    transform: "matrix(0.0024 -1 1 0.0024 69.3458 140.9978)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.705,
    y: 32.083,
    transform: "matrix(0.0032 -1 1 0.0032 69.301 136.1131)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.275,
    y: 34.517,
    transform: "matrix(0.0028 -1 1 0.0028 64.485 136.1234)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.858,
    y: 32.07,
    transform: "matrix(0.0032 -1 1 0.0032 64.4842 131.2534)",
    fill: "#000119",
    width: 2.441,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.429,
    y: 34.504,
    transform: "matrix(0.0028 -1 1 0.0028 59.6671 131.2646)",
    fill: "#000119",
    width: 2.441,
    height: 2.422
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.814,
    y: 34.558,
    transform: "matrix(0.0032 -1 1 0.0032 78.897 150.6881)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.396,
    y: 32.11,
    transform: "matrix(0.0028 -1 1 0.0028 78.9807 145.8447)",
    fill: "#000119",
    width: 2.441,
    height: 2.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.967,
    y: 34.543,
    transform: "matrix(0.0024 -1 1 0.0024 74.168 145.8565)",
    fill: "#000119",
    width: 2.441,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.55,
    y: 32.097,
    transform: "matrix(0.0024 -1 1 0.0024 74.203 140.9991)",
    fill: "#000119",
    width: 2.44,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.121,
    y: 34.531,
    transform: "matrix(0.0024 -1 1 0.0024 69.3458 140.9978)",
    fill: "#000119",
    width: 2.44,
    height: 2.423
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.506,
    y: 34.583,
    transform: "matrix(0.0024 -1 1 0.0024 88.6321 160.4355)",
    fill: "#000119",
    width: 2.441,
    height: 2.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.089,
    y: 32.135,
    transform: "matrix(0.0028 -1 1 0.0028 88.6183 155.5636)",
    fill: "#000119",
    width: 2.441,
    height: 2.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.658,
    y: 34.572,
    transform: "matrix(0.0028 -1 1 0.0028 83.7603 155.5602)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.243,
    y: 32.125,
    transform: "matrix(0.0032 -1 1 0.0032 83.7522 150.6913)",
    fill: "#000119",
    width: 2.44,
    height: 2.421
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.814,
    y: 34.558,
    transform: "matrix(0.0032 -1 1 0.0032 78.897 150.6881)",
    fill: "#000119",
    width: 2.44,
    height: 2.422
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.782,
    y: 54.692,
    fill: "#000119",
    width: 2.258,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.524,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.266,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.007,
    y: 52.419,
    fill: "#000119",
    width: 2.259,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.75,
    y: 54.692,
    fill: "#000119",
    width: 2.256,
    height: 2.275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.816,
    y: 54.692,
    fill: "#000119",
    width: 2.258,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.558,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.299,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.041,
    y: 52.419,
    fill: "#000119",
    width: 2.259,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.783,
    y: 54.692,
    fill: "#000119",
    width: 2.257,
    height: 2.275
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.848,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.592,
    y: 52.419,
    fill: "#000119",
    width: 2.256,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.333,
    y: 54.692,
    fill: "#000119",
    width: 2.26,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.075,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.816,
    y: 54.692,
    fill: "#000119",
    width: 2.258,
    height: 2.275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.882,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.624,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.365,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.107,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.85,
    y: 54.692,
    fill: "#000119",
    width: 2.257,
    height: 2.275
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.917,
    y: 54.692,
    fill: "#000119",
    width: 2.256,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.658,
    y: 52.419,
    fill: "#000119",
    width: 2.259,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.398,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.141,
    y: 52.419,
    fill: "#000119",
    width: 2.257,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.882,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.949,
    y: 54.692,
    fill: "#000119",
    width: 2.258,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.691,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.434,
    y: 54.692,
    fill: "#000119",
    width: 2.257,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.172,
    y: 52.419,
    fill: "#000119",
    width: 2.261,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.917,
    y: 54.692,
    fill: "#000119",
    width: 2.256,
    height: 2.275
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.955,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.697,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.438,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.181,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.922,
    y: 54.692,
    fill: "#000119",
    width: 2.258,
    height: 2.275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.99,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.731,
    y: 52.419,
    fill: "#000119",
    width: 2.259,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.472,
    y: 54.692,
    fill: "#000119",
    width: 2.26,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.214,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.957,
    y: 54.692,
    fill: "#000119",
    width: 2.257,
    height: 2.275
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.021,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.766,
    y: 52.419,
    fill: "#000119",
    width: 2.256,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.506,
    y: 54.692,
    fill: "#000119",
    width: 2.26,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.249,
    y: 52.419,
    fill: "#000119",
    width: 2.257,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.99,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.056,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.796,
    y: 52.419,
    fill: "#000119",
    width: 2.26,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.539,
    y: 54.692,
    fill: "#000119",
    width: 2.257,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.28,
    y: 52.419,
    fill: "#000119",
    width: 2.259,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.021,
    y: 54.692,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131.397,
    y: 52.419,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.656,
    y: 54.694,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.914,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.362,
    y: 52.419,
    fill: "#000119",
    width: 2.26,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.622,
    y: 54.694,
    fill: "#000119",
    width: 2.258,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.88,
    y: 52.419,
    fill: "#000119",
    width: 2.258,
    height: 2.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.138,
    y: 54.694,
    fill: "#000119",
    width: 2.26,
    height: 2.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.397,
    y: 52.419,
    fill: "#000119",
    width: 2.259,
    height: 2.275
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M130.624,29.294c-2.092,0-3.793-1.699-3.793-3.79s1.701-3.792,3.793-3.792c2.09,0,3.791,1.701,3.791,3.792 S132.714,29.294,130.624,29.294z M130.624,22.244c-1.799,0-3.262,1.462-3.262,3.261c0,1.797,1.463,3.259,3.262,3.259 c1.797,0,3.259-1.462,3.259-3.259C133.883,23.706,132.421,22.244,130.624,22.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M129.408,23.3c0.269-0.049,0.663-0.086,1.025-0.086c0.57,0,0.945,0.11,1.196,0.337 c0.204,0.186,0.326,0.467,0.326,0.792c0,0.54-0.343,0.902-0.772,1.05v0.019c0.312,0.109,0.504,0.406,0.602,0.835 c0.135,0.576,0.231,0.976,0.319,1.137h-0.555c-0.067-0.124-0.159-0.475-0.269-0.99c-0.123-0.571-0.351-0.785-0.836-0.804h-0.503 v1.794h-0.534V23.3z M129.942,25.185h0.546c0.571,0,0.934-0.313,0.934-0.785c0-0.535-0.388-0.769-0.952-0.769 c-0.257,0-0.436,0.019-0.527,0.044V25.185z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiworld);
export default __webpack_public_path__ + "static/media/taxiworld.263003652865fd2f9e2e77db5e785d72.svg";
export { ForwardRef as ReactComponent };